import React, { useContext, useEffect, useState } from 'react';
import { __BrandDetailPath } from '../brandDetail.scripts';
import { __BrandRankingPropsType } from './ranking.type';
import { GlobalContext } from '@/context';
import { Empty, message, Pagination, Spin } from 'antd';
import styles from './ranking.module.scss';
import { __BrandRankingCheckFilterChange, __BrandRankingFetchParams } from './ranking.scripts';
import { RestAPI } from '@/scripts';
import { BrandRankingType, PaginationType } from '@/types';
import { API } from '@/data';
import cardStyles from './listCard/listCard.module.scss';
import RankingReviewsComp from './reviews/reviews.index';
import __RankCardComp from './bestCard/bestCard.index';
export default function BrandRankingComp(props: __BrandRankingPropsType) {
  const {
    langText
  } = useContext(GlobalContext);
  const lang = langText.brandDetail;
  const filters = props.filters;
  const [ranking, setRanking] = useState(props.ranking);
  useEffect(() => {
    const path = __BrandDetailPath(filters, langText.lang, props.data.slug);
    window.history.replaceState(null, '', path);
    const descriptionMetaTag: HTMLLinkElement | null = document.querySelector('link[rel="canonical"]');
    if (descriptionMetaTag) descriptionMetaTag.href = path.href;
    if (__BrandRankingCheckFilterChange(filters, props.initialFilters)) setRanking(props.ranking);else {
      const newParams = __BrandRankingFetchParams(filters, props.data.slug);
      setRanking(undefined);
      RestAPI.get<PaginationType<BrandRankingType<'detail'>>>(API.ranking.index, newParams).then(res => setRanking(res.data)).catch(() => message.error(langText.general.error));
    }
  }, [filters]);
  return <div className={`main-content ${styles['ranking']}`} data-sentry-component="BrandRankingComp" data-sentry-source-file="ranking.index.tsx">
            {ranking ? ranking.count ? <>
                        <div className={`${styles['items']}`}>
                            {ranking.data.map(item => <div key={item.id} className={`flex-1 ${styles['ranking-card']}`}>
                                    <p className={`t-dark1 t-h4 t-700 ps-3 align-items-center ${styles['category']}`}>
                                        {item.category?.title}
                                    </p>
                                    <div className={`${styles['content']}`}>
                                        {[item.higher_brand_category, item, item.lower_brand_category].map((rank, index) => <React.Fragment key={index}>
                                                    {rank ? <__RankCardComp isActive={rank.brand.slug === item.brand.slug} data={rank} /> : null}
                                                </React.Fragment>)}
                                    </div>
                                </div>)}
                            {ranking.data.length > 1 ? <div className={`flex-1 ${cardStyles['ranking-card']} ${cardStyles['spacer']}`} /> : null}
                        </div>
                        <div className={`${styles['pagination-layout']} ${(ranking?.num_of_pages ?? 0) > 1 ? '' : 'd-none'} center-content mt-6`}>
                            <div className={`${styles['pagination']} center-content`}>
                                <Pagination size="small" current={filters.page ? Number(filters.page) : 1} pageSize={5} total={ranking?.count} showSizeChanger={false} hideOnSinglePage onChange={e => props.setFilters({
            ...filters,
            page: e.toString()
          })} />
                            </div>
                        </div>
                    </> : <Empty className="mt-8" description={lang.emptyRanking} /> : <div className="w-100 pv-6 center-content">
                    <Spin />
                </div>}
            <RankingReviewsComp brand={props.data} data-sentry-element="RankingReviewsComp" data-sentry-source-file="ranking.index.tsx" />
        </div>;
}